import { styled } from 'linaria/react';
import React, { FC, useEffect } from 'react';
import { Header } from 'src/ui/organisms/header';
import { useWindowSize } from 'react-use';

const PageContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: var(--header-height) 1fr;
`;
const Content = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	overflow-y: scroll;
	padding: 16px;
	max-height: calc(var(--view-height) - var(--header-height));
`;

type PageProps = {
	title?: string;
}

export const Page: FC<PageProps> = (props) => {
	const { children, title } = props;
	const { width } = useWindowSize();

	useEffect(() => {
		if (width < 600) {
			document.documentElement.style.setProperty('--view-height', window.innerHeight + 'px');
		} else {
			document.documentElement.style.setProperty('--view-height', '100vh');
		}
	}, [width]);

	return (
		<PageContainer>
			<Header title={title}/>
			<Content>
				{children}
			</Content>
		</PageContainer>
	);
};
